import {
  dateFormatter, dateTimeFormatter, registryLinkFormatter, userFIOFormatter,
} from '../../../utils/formatters';
import { intlShape } from '../../../components/base/IntlProviderWrapper';
import { REGISTRY_TYPE } from '../../../configs';

const { formatMessage } = intlShape;

export const driverColumns = [
  {
    dataField: 'driver_name',
    text: 'ФИО',
    headerClassName: 'driver-name-column',
    formatter: (e, item) => userFIOFormatter({
      first_name: item.first_name,
      middle_name: item.middle_name,
      last_name: item.last_name,
    }),
    sortField: 'driver_name',
  },
  {
    dataField: 'driver_citizenship',
    text: 'Гражданство',
    headerClassName: 'citizenship-column',
    formatter: item => formatMessage({ id: `citizenship.type.${item}` }),
  },
  {
    dataField: 'driver_inn',
    text: 'ИНН',
    headerClassName: 'inn-column',
  },
  {
    dataField: 'driver_license_experience',
    text: 'Стаж',
    headerClassName: 'experience-column',
  },
  {
    dataField: 'driver_license',
    text: 'Водительское удостоверение',
    formatter: (e, item) => `${item?.driver_license_series || ''} ${item?.driver_license_number || ''} `,
    headerClassName: 'driver-license-column',
  },
  {
    dataField: 'driver_license_valid_until_date',
    text: 'Срок действия водительского удостоверения',
    headerClassName: 'license-expiry-column',
    formatter: dateFormatter,
  },
];

export const transportColumns = [
  {
    dataField: 'vehicle_registry_number',
    text: 'Номер записи',
    dataClassName: 'align-middle',
    hidden: true,
  },
  {
    dataField: 'vehicle_brand',
    text: 'Марка ТС',
    dataClassName: 'align-middle',
    hidden: true,
  },
  {
    dataField: 'vehicle_model',
    text: 'Модель ТС',
    dataClassName: 'align-middle',
    hidden: true,
  },
  {
    dataField: 'vehicle_color',
    text: 'Цвет ТС',
    dataClassName: 'align-middle',
    hidden: true,
  },
  {
    dataField: 'vehicle_lpn',
    headerClassName: 'vehicle-reg-number-column',
    text: 'ГРН ТС',
  },
  {
    dataField: 'registry_vehicle',
    text: 'Год выпуска',
    dataClassName: 'align-middle',
    formatter: item => item?.vehicle_year,
    hidden: true,
  },
  {
    dataField: 'carrier_name',
    text: 'Перевозчик',
    dataClassName: 'align-middle',
    hidden: true,
  },
];

export const serviceOrderColumns = [
  {
    dataField: 'record_number',
    text: 'Номер записи',
    dataClassName: 'align-middle',
    headerClassName: 'record-number-column',
    hidden: false,
  },
  {
    dataField: 'service_name',
    text: 'Наименование службы заказа',
    dataClassName: 'align-middle',
    headerClassName: 'service-name-column',
    hidden: false,
  },
  {
    dataField: 'entry_date',
    text: 'Дата внесения записи',
    dataClassName: 'align-middle',
    headerClassName: 'entry-date-column',
    hidden: false,
  },
  {
    dataField: 'inn',
    text: 'ИНН',
    dataClassName: 'align-middle',
    headerClassName: 'inn-column',
    hidden: false,
  },
  {
    dataField: 'ogrn',
    text: 'ОГРН / ОГРНИП',
    dataClassName: 'align-middle',
    headerClassName: 'ogrn-column',
    hidden: false,
  },
  {
    dataField: 'validity_end_date',
    text: 'Дата окончания срока действия права',
    dataClassName: 'align-middle',
    headerClassName: 'validity-end-date-column',
    hidden: false,
  },
];

export const carrierColumns = [
  {
    dataField: 'vehicle',
    sortField: 'registry_id',
    text: 'Номер записи',
    formatter: item => registryLinkFormatter(item?.number, REGISTRY_TYPE.VEHICLE, { registry_id: item?.id }),
  },
  {
    dataField: 'carrier_short_name',
    text: 'Наименование перевозчика',
    dataClassName: 'align-middle',
    headerClassName: 'service-name-column',
    hidden: false,
  },
  {
    dataField: 'created_at',
    text: 'Дата внесения записи',
    dataClassName: 'align-middle',
    headerClassName: 'entry-date-column',
    hidden: false,
    formatter: dateFormatter,
  },
  {
    dataField: 'carrier_inn',
    text: 'ИНН',
    dataClassName: 'align-middle',
    headerClassName: 'inn-column',
    hidden: false,
  },
  {
    dataField: 'carrier_ogrn',
    text: 'ОГРН / ОГРНИП',
    dataClassName: 'align-middle',
    headerClassName: 'ogrn-column',
    hidden: false,
  },
  {
    dataField: 'updated_at',
    text: 'Дата окончания срока действия права',
    dataClassName: 'align-middle',
    headerClassName: 'validity-end-date-column',
    hidden: false,
    formatter: dateFormatter,
  },
];

export const violationColumns = [
  {
    dataField: 'applicant',
    headerClassName: 'carrier-column',
    text: 'Перевозчик',
    formatter: item => item?.carrier_short_name || item?.carrier_full_name,
  },
  {
    dataField: 'resolution_number',
    headerClassName: 'number-violation-column',
    text: 'Номер постановления',
  },
  {
    dataField: 'resolution_at',
    headerClassName: 'resolution-date-column',
    text: 'Дата постановления',
    formatter: dateFormatter,
  },
  {
    dataField: 'koap',
    headerClassName: 'article-column',
    text: 'Статья КоАП РФ',
    // formatter: item => item.name,
  },
  {
    dataField: 'uin',
    headerClassName: 'uin-column',
    text: 'УИН',
  },
  {
    dataField: 'created_at',
    headerClassName: 'violation-date-column',
    text: 'Дата и время нарушения',
    formatter: dateTimeFormatter,
  },
  {
    dataField: 'sum',
    headerClassName: 'fine-amount-column',
    text: 'Сумма штрафа',
  },
];
